<template>
  <div class="MobileBox">
    <span v-if="jurisdiction.indexOf('bdyCrm.viewBDCrm') != -1" @click="showDialog()">
      <i class="el-icon-mobile-phone" /> CRM 移动端
    </span>
    <span v-else @click="showDialog()">
      <i class="el-icon-mobile-phone" /> 移动端
    </span>
    <el-dialog :visible.sync="visible" width="1000px">
      <img v-if="jurisdiction.indexOf('bdyCrm.viewBDCrm') != -1" src="./../../assets/imgs/crm_mb_pic.png" width="100%" height="100%" alt="">
      <img v-else src="./../../assets/imgs/jdCrm_pic.png" width="100%" height="100%" alt="">
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MobileBox',
  data() {
    return {
      visible: false
    }
  },
  computed: {
    ...mapGetters([
      'jurisdiction'
    ])
  },
  created() {
    window.addEventListener('message', this.onMessage)
  },
  destroyed() {
    window.removeEventListener('message', this.onMessage)
  },
  methods: {
    onMessage(ev) {
      if (ev.data === 'show-mobile-ad') {
        this.showDialog()
      }
    },
    showDialog() {
      this.visible = true
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header{
  background: #fff;
}
.navbar-text {
  margin-right: 25px;
  cursor: pointer;
}
.MobileBox {
  cursor: pointer;
  margin-right: 25px;
  color: #a3a6ae;
  font-size: 14px;
}
</style>
